var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidenavReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 9.16667H3.33332M16.6667 9.16667C17.5871 9.16667 18.3333 9.91286 18.3333 10.8333V14.1667C18.3333 16.0076 16.8409 17.5 15 17.5H4.99999C3.15904 17.5 1.66666 16.0076 1.66666 14.1667V10.8333C1.66666 9.91286 2.41285 9.16667 3.33332 9.16667M16.6667 9.16667V7.5C16.6667 6.57953 15.9205 5.83333 15 5.83333M3.33332 9.16667V7.5C3.33332 6.57953 4.07952 5.83333 4.99999 5.83333M15 5.83333H4.99999M15 5.83333V4.16667C15 3.24619 14.2538 2.5 13.3333 2.5H6.66666C5.74618 2.5 4.99999 3.24619 4.99999 4.16667V5.83333M8.33332 11.6667H11.6667",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidenavReports);
export default __webpack_public_path__ + "static/media/sidenav-reports.8822810b62829d8b03b2dd8743f2a32d.svg";
export { ForwardRef as ReactComponent };